import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faBars, faXmark } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'ticketing-hamburger-overlay',
  imports: [FaIconComponent],
  templateUrl: './hamburger-overlay.component.html',
  styleUrl: './hamburger-overlay.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HamburgerOverlayComponent {
  menuState = input.required<boolean>();
  buttonClick = output<void>();

  protected onButtonClick() {
    this.buttonClick.emit();
  }

  protected readonly faXmark = faXmark;
  protected readonly faBars = faBars;
}
